'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * `BadgePosition` is a component that positions the badge.
 *
 * @example
 * <BadgePosition placement='top-right' overlap='circle'>
 *  <Badge count={5} maxCount={10} />
 *  <Element />
 * </BadgePosition>
 */
const BadgePosition = forwardRef(function BadgePlacement({ className, overlap = 'rectangle', placement = 'top-right', ...rest }, ref) {
    return (jsx("span", { className: cl('ds-badge--position', className), "data-overlap": overlap, "data-placement": placement, ref: ref, ...rest }));
});

export { BadgePosition };
